package strings

import io.github.skeptick.libres.strings.PluralForms
import io.github.skeptick.libres.strings.VoidPluralString
import io.github.skeptick.libres.strings.getCurrentLanguageCode
import kotlin.String

public object StringsEn : Strings {
  override val locale: String = "en"

  override val app_name: String = "Website"

  override val home_screen: String = "Home"

  override val education_screen: String = "Education"

  override val skills_screen: String = "Skills"

  override val experience_screen: String = "Experience"

  override val projects_screen: String = "Projects"

  override val project_details_screen: String = "Project Details"

  override val social_media_screen: String = "Social Media"

  override val achievements_screen: String = "Achievements"

  override val homepage_description: String =
      "I'm passionate about tech and focused on Android app development."

  override val homepage_tutor_website: String = "My tutoring website"

  override val main: String = "Main"

  override val skills: String = "Skills"

  override val projects: String = "Projects"

  override val experience: String = "Experience"

  override val education: String = "Education"

  override val social_media: String = "Social Media"

  override val achievements: String = "Achievements"

  override val resume: String = "Resumé"

  override val no_results: String = "Could not find anything..."

  override val search_placeholder: String = "Search..."

  override val search: String = "Search"

  override val home_description: String =
      "I am a passionate software developer with a focus on Android app development. Here, you can explore my skills, projects, and achievements."

  override val skills_description: String =
      "I have a diverse skill set in software development, including expertise in various programming languages, frameworks, and tools. My focus is on creating efficient and user-friendly applications."

  override val projects_description: String =
      "I have worked on a variety of projects, ranging from mobile applications to web development. Each project showcases my ability to solve complex problems and deliver high-quality software solutions."

  override val experience_description: String =
      "With experience in both commercial and academic projects, I have honed my skills in software engineering, project management, and teamwork. I am committed to continuous learning and professional growth."

  override val education_description: String =
      "I hold a Bachelor's degree in Computer Science from Jagiellonian University, where I gained a solid foundation in programming, algorithms, and software development methodologies."

  override val social_media_description: String =
      "Connect with me on social media to stay updated on my latest projects, achievements, and insights into the world of software development."

  override val achievements_description: String =
      "I have received several awards and recognitions for my contributions to software development and education. These achievements reflect my dedication to excellence and my passion for technology."

  override val skills_button: String = "Skills"

  override val projects_button: String = "Projects"

  override val experience_button: String = "Experience"

  override val education_button: String = "Education"

  override val social_media_button: String = "Social Media"

  override val achievements_button: String = "Achievements"

  override val view_more: String = "View More"

  override val stack_title: String = "// TECH STACK"

  override val hero_label: String = "// hi, I'm"

  override val hero_title_name: String = "Michał Cyran"

  override val story_label: String = "// my story"

  override val story_intro: String =
      "My journey with Kotlin started on the Android Course at university. After finishing my bachelor's degree, I spent 2 years diving deep into the language. I've built many apps within that time. You can browse them all at Projects page."

  override val focus_title: String = "// currently exploring"

  override val focus_coroutines: String = """
      |Currently I'm deep diving into Kotlin Coroutines. My target is to go through 15 project
      |        involving different aspects of coroutines, from scratch to advanced.
      """.trimMargin()

  override val focus_coroutines_link_label: String = "See the repo"

  override val beyond_title: String = "// beyond code"

  override val beyond_tutoring: String = """
      |'m working as a math tutor, which confirms my high math skills
      |        (hence the problem-solving) as well as good cooperation with people and my ability to run a
      |        business.
      """.trimMargin()

  override val learning_title: String = "// staying up to date"

  override val learning_book: String = "Read: Kotlin in Action"

  override val learning_channels: String =
      "Regularly watching: KotlinConf, Dave Leeds, Philipp Lackner, Stevdza-San"

  override val skills_title: String = "Technical Skills"

  override val skills_subtitle: String =
      "A collection of my programming languages, frameworks, and other technical skills."

  override val programming_languages: String = "Programming Languages"

  override val frameworks: String = "Frameworks"

  override val markup_style: String = "Markup & Style"

  override val libraries: String = "Libraries"

  override val languages: String = "Languages"

  override val beginner: String = "Beginner"

  override val competent: String = "Competent"

  override val proficient: String = "Proficient"

  override val advanced: String = "Advanced"

  override val expert: String = "Expert"

  override val native: String = "Native"

  override val c1: String = "C1"

  override val projects_title: String = "Programming projects"

  override val projects_subtitle: String =
      "A collection of my programming projects, showcasing my skills and experience in software development."

  override val mobile_application: String = "Mobile application"

  override val web_application: String = "Web application"

  override val desktop_application: String = "Desktop application"

  override val multiplatform_application: String = "Multiplatform application"

  override val library: String = "Library"

  override val console_application: String = "Console application"

  override val game: String = "Game"

  override val other: String = "Other"

  override val commercial_project: String = "Commercial"

  override val academic_project: String = "Academic"

  override val tools_project: String = "Tools"

  override val practice_project: String = "Practice"

  override val personal_project: String = "Personal"

  override val project_overview: String = "Project Overview"

  override val technical_overview: String = "Technical Overview"

  override val release_year: String = "Release year"

  override val tech_stack: String = "Tech stack"

  override val technical_description_placeholder: String = "Technical description isn't ready yet"

  override val screenshots: String = "Screenshots"

  override val projects_master_system_shortDescription: String =
      "Application for managing tournaments with a custom algorithm"

  override val projects_master_system_description: String =
      "This tournament management application was developed on commission to facilitate competitive match play according to a client-specific algorithm. The app provides a user-friendly interface for entering match results, automatically pairs teams for the next round based on the algorithm, calculates points, and generates comprehensive PDF summaries of the tournament's progress. Additionally, it creates graphs to visually represent the algorithm's logic and outcomes. The application is translated into four languages using Python's gettext module, ensuring accessibility for a diverse user base. This project showcases my ability to deliver tailored, multilingual software solutions that meet specific client requirements and enhance the management of complex tournament structures."

  override val projects_master_system_technicalDescription: String =
      "Tournament management application developed on commission, implementing a custom client-specific pairing algorithm. Originally built in Python with KivyMD — the project was later migrated to Kotlin Multiplatform to support browser and mobile platforms in the future. The current version is based on Compose Multiplatform (WasmJS) with a shared UI across platforms — supporting Compose Desktop (JVM) and a web version. MVI architecture, navigation via Navigation 3, no backend. Data persisted locally — in localStorage via the Kotlin/JS API in the browser, and in JSON files on desktop."

  override val projects_asertiv_shortDescription: String = "Assertiveness training app"

  override val projects_asertiv_description: String =
      "Assertiveness training app. Created in collaboration with a psychology student. The app assigns the user gradually more difficult tasks that develop their assertiveness. The user chooses the days on which they want to perform them. I implemented a custom, extensive algorithm for calculating the user's streak of days, which takes into account time freezes, side tasks, days off, skipped tasks. The user can track their progress in the form of a list of completed tasks or a calendar with marked days on which they completed a task. They can also add their own notes to tasks. The app also offers psychological knowledge along with various psychological techniques to which some tasks refer."

  override val projects_asertiv_technicalDescription: String =
      "Tasks are saved in the database using Room. Techniques, tasks, user progress are of course separated into separate tables, which means the app has to execute non-trivial SQL queries to correctly join the data. The streak algorithm taking into account the factors mentioned in the description beside was complex enough that no AI model was able to write it, so I created it myself from scratch. The \"Knowledge\" section in the app was created in the form of an .md file so that my co-creator (unrelated to IT) could easily prepare it, while the app converts it into a native interface in Jetpack Compose using an appropriate library."

  override val projects_vl_shortDescription: String =
      "Valorant Lineups is a mobile app for Valorant players that helps them during gameplay"

  override val projects_vl_description: String =
      "Valorant Lineups is a mobile app created for Valorant players to assist them during gameplay. The app offers a wide collection of lineups, allowing players to execute advanced techniques without the need to memorize specific settings on the map. With this app, players can achieve better results in the game and climb higher ranks. It was the first app of its kind for Valorant available on the Play Store, achieving success with over 100,000 downloads. This project highlights my skills in delivering innovative and effective solutions."

  override val projects_vl_technicalDescription: String =
      "Application built with Kotlin Multiplatform and a UI based on Compose Multiplatform — available as an Android app and a web app hosted on GitHub Pages. Architecture based on MVI, with shared business logic and ViewModels in commonMain; platform-specific elements handled via the expect/actual mechanism (e.g. checking for updates via Google Play — not applicable in the browser).  App data is stored in JSON files bundled with the application — generated by a Python script querying the database with raw SQL. This approach stems from Room's limitation of not supporting database initialization from a file on platforms other than Android. User's favourite lineups are stored in Room on both platforms, ensuring on-device persistence without the need for a backend. HTTP communication handled by Ktor Client (OkHttp engine on Android, JS on web) with serialization via kotlinx.serialization — used to communicate with Firebase Authentication for login via Riot Games OAuth 2.0. Images are loaded from a public Cloudflare R2 bucket and cached by Coil. Navigation based on Navigation 3 with type-safe routes."

  override val projects_demiurg_shortDescription: String =
      "Set of 2 applications - a creator and an interpreter of text-based games"

  override val projects_demiurg_description: String =
      "Demiurg is an application developed as part of a Software Engineering course, created by a team of five people. The project consists of two separate applications: a game creator and an interpreter for text-based games. The creator allows users to design complex game worlds with mechanics such as non-linear quests. It enables the creation of detailed interactive narratives, while the interpreter provides an immersive experience during gameplay. This project demonstrates my ability to work in a team and create independent yet cooperating programs."

  override val projects_demiurg_technicalDescription: String =
      "Both the interpreter and the creator were built in Python, the interface in KivyMD, with prior design in Figma. A JSON-file-based communication protocol was established between the applications — the creator generates these files, and the interpreter reads them. Tests were also prepared for the project and are available in the GitHub repository."

  override val projects_daymath_shortDescription: String =
      "DayMath is an educational application for Polish students, featuring math quizzes, explanations, and animations."

  override val projects_daymath_description: String =
      "An educational application that aims to enhance math learning through a variety of interactive features, including math quizzes, detailed text explanations of various topics, and animations that visualize and explain complex problems. These tools work together to provide an engaging and effective educational experience. It is my most advanced project, combining multiple technologies. The app itself is built in Kotlin, but the task texts required the use of LaTeX, which is well-supported in Python. The app also connects to Firebase, where users' learning progress is saved. This project highlights my commitment to developing my tutoring business and combines my skills in computer science, mathematics, education, and linguistics."

  override val projects_daymath_technicalDescription: String =
      "Android application built in Kotlin with a UI based on Jetpack Compose, MVI architecture. Code organized into core and features packages, each internally divided into data, domain, and presentation layers. The core of the application is an extensive math exercise module — ranging from basic exercises (multiplication table, unit conversion) to advanced ones (reading function properties from a graph, linear equation and inequality generators). Exercise logic is based on abstract classes and interfaces representing a generic exercise, eliminating code duplication across implementations. For equation rendering, custom classes were written to represent mathematical objects (expressions, equations, inequalities) along with their rendering in Compose — due to the lack of native LaTeX support on Android. Data stored locally in Room with access via ORM (DAO) and reactive reads through Kotlin Flow and coroutines. Firebase communication handled by Ktor Client (OkHttp engine) with serialization via kotlinx.serialization — the app uses Firebase Authentication (Google account login) and Firestore as a remote database. Navigation based on Navigation 3 with type-safe routes."

  override val projects_movie_ai_shortDescription: String =
      "Desktop app recommending movies based on user ratings"

  override val projects_movie_ai_description: String =
      "The Movie Recommendation System is a desktop application created in collaboration with a colleague as part of a Fundamentals of Artificial Intelligence course. This app enables users to rate movies they have watched, and employs AI algorithms to recommend new movies tailored to their preferences. By analyzing user ratings and employing sophisticated recommendation techniques, the system provides personalized movie suggestions, enhancing the user’s viewing experience. This project highlights our practical application of AI principles and our ability to develop user-centric, intelligent software solutions."

  override val projects_movie_ai_technicalDescription: String =
      "Built on the SVD (Singular Value Decomposition) algorithm. A more detailed discussion is available in the .pdf file in the repository."

  override val projects_generator_tabliczek_shortDescription: String =
      "Application generating room number and name plates"

  override val projects_generator_tabliczek_description: String =
      "This application was created in collaboration with a colleague for a programming course in C#. It generates room number and name plates that can be printed and hung next to room doors. The application allows users to choose the font, logo, and text color. It also enables saving the project between sessions."

  override val projects_generator_tabliczek_technicalDescription: String = "Interface built in WPF."

  override val projects_scheduler_shortDescription: String =
      "Application for generating lesson schedules integrated with Discord."

  override val projects_scheduler_description: String = ""

  override val projects_scheduler_technicalDescription: String =
      "The image is generated entirely using the Pillow library. Discord integration via a bot controlled with the Discord.py library. Notifications implemented through a dictionary that maps a name (sometimes with a surname) to a Discord user ID."

  override val projects_binary_clock_shortDescription: String =
      "Binary clock made using Compose Multiplatform"

  override val projects_binary_clock_description: String =
      "Binary clock made using Compose Multiplatform"

  override val projects_subtitles_shifter_shortDescription: String =
      "Simple script allowing to shift subtitles in .srt files"

  override val projects_subtitles_shifter_description: String =
      "Simple script allowing to shift subtitles in .srt files. It was created for my individual need to shift subtitles that did not match the movie version (were delayed by a few seconds forward or backward)."

  override val projects_youtube_downloader_shortDescription: String =
      "Multithreaded script allowing to download songs from YouTube"

  override val projects_youtube_downloader_description: String =
      "This application allows you to download a playlist from Spotify, via YouTube. It requires the user to export the playlist to a .csv file using the Exportify application, and then downloads the songs from YouTube in separate threads, searching for them by name and artist, and saving them in an organized way - creating folders with artists, and naming each song with its title."

  override val projects_tic_tac_toe_shortDescription: String =
      "Simple Tic-Tac-Toe game that can be played with a friend on Discord"

  override val projects_tic_tac_toe_description: String =
      "Simple Tic-Tac-Toe game that can be played with a friend on Discord"

  override val projects_crypto_tracker_shortDescription: String =
      "App tracking cryptocurrency prices"

  override val projects_crypto_tracker_description: String =
      "App tracking cryptocurrency prices. It allows adding cryptocurrencies to track, and displays their current prices along with a chart of changes over the last 24 hours."

  override val projects_tutor_website_shortDescription: String = "Website with my tutoring offer"

  override val projects_tutor_website_description: String =
      "This website was developed by me to showcase my tutoring offer in mathematics and computer science. It contains all the details regarding lessons, rates, reviews, and contact information. The site was built entirely using Jetpack Compose."

  override val projects_mobile_remote_shortDescription: String =
      "Mobile remote control for computer media player"

  override val projects_mobile_remote_description: String =
      "This project consists of two applications - a client and a server, which are useful for watching movies. The server application runs on the computer, while the client runs on the phone. This allows you to control movie playback from your phone, such as pausing, fast-forwarding or rewinding, adjusting volume, and muting sound, while being away from the computer."

  override val projects_mobile_remote_technicalDescription: String =
      "A set of two applications enabling remote multimedia control within a local network — an Android client and a desktop server. The client is built in Kotlin with a UI based on Jetpack Compose, MVI architecture. It sends HTTP requests to the server via Ktor Client. The server's IP address is stored locally in DataStore Preferences. Single-screen application. The server is built in Kotlin with Spring Boot, exposing a REST API consumed by the client. Multimedia control is handled by NirCmd — a Windows command-line utility for system-level media control, invoked from the server."

  override val projects_todo_list_shortDescription: String =
      "Classic mobile app that allows you to save your todos"

  override val projects_todo_list_description: String =
      "Classic mobile app that allows you to save your todos. It enables creating, editing, and deleting tasks. Tasks have their own priority and completion date. Everything is saved offline on the device."

  override val projects_screenshot_processor_shortDescription: String =
      "Application facilitating my work on the Valorant Lineups app"

  override val projects_screenshot_processor_description: String =
      "This application facilitates my work on the Valorant Lineups app. It allows for quick saving of in-game screenshots in folders, according to my own data structure for this app. It has a list of skills for each agent, a map index, and types of screenshots."

  override val projects_website_shortDescription: String = "My Portfolio Website"

  override val projects_website_description: String =
      "My portfolio website, which you are currently browsing. I created it solely using Kobweb."

  override val projects_days_counter_shortDescription: String =
      "Application for counting days between dates"

  override val projects_days_counter_description: String =
      " Application for counting days between dates. It can be run as a mobile app on Android, desktop, or web. It allows users to save any number of date pairs, between which it calculates: the number of days that have passed, and the number of days remaining."

  override val projects_typing_speed_tester_shortDescription: String =
      "Application for checking user's typing speed - mobile, desktop and native web"

  override val projects_typing_speed_tester_description: String = "."

  override val projects_typing_speed_tester_technicalDescription: String = "."

  override val projects_tic_tac_toe_kotlin_shortDescription: String =
      "Client and server for Tic-Tac-Toe game over a local network"

  override val projects_tic_tac_toe_kotlin_description: String =
      "Client and server for Tic-Tac-Toe game over a local network. The client can be run as a desktop, web, or mobile app on Android. Created using sockets. It provides type-safe message handling and verification."

  override val projects_math_tools_shortDescription: String =
      "Application facilitating remote math tutoring"

  override val projects_math_tools_description: String =
      "Application facilitating remote math tutoring. It draws necessary objects such as tables, coordinate systems, chessboards, solids (pyramids and prisms with various bases). It allows for easy copying to the clipboard with a transparent background, enabling direct pasting into any graphic program used for tutoring."

  override val projects_function_solver_shortDescription: String =
      "Application for practicing reading function properties from graphs"

  override val projects_function_solver_description: String =
      "Application for practicing reading function properties from graphs. Created for high school graduates. It allows for effective learning of tasks in this topic, thoroughly preparing for the graduation exam. The app generates graphs, allows inputting answers, checks them, and provides correct solutions. Answers are always simplified to the simplest form, even in the case of piecewise functions."

  override val projects_function_solver_technicalDescription: String =
      "Functions in the program are treated as lists of point sets. I built the graph rendering in the UI from scratch, with fine-tuned coordinate system parameters to ensure functions have 'readable' values (e.g. integer roots). I also wrote all the algorithms myself for determining function parameters (domain, range, monotonicity intervals, positive/negative/non-positive/non-negative intervals, roots). Custom classes for representing points, intervals, and sets. Custom algorithm for interval normalization."

  override val projects_calico_companion_shortDescription: String =
      "An app for preparing a game session in the paper version of Calico"

  override val projects_calico_companion_description: String =
      "An app for preparing a game session in the paper version of Calico. The user can draw cats, patterns, and projects depending on the number of players. The app was created for personal use"

  override val projects_matura_tasks_hub_shortDescription: String =
      "A website with high school final exam tasks grouped by topics and subcategories"

  override val projects_matura_tasks_hub_description: String =
      "A website with high school final exam tasks grouped by topics and subcategories. Created with my students in mind. It also streamlines my tutoring sessions. Beyond the features available on other sites of this type, I added categorization of tasks based on their frequency on the exam – from guaranteed exam questions to non-standard tasks – so that students preparing for the exam know which tasks to focus on. Additionally, each task has a copy-to-clipboard button, allowing me to quickly copy and paste any task into the graphics program used during tutoring."

  override val projects_matura_tasks_hub_technicalDescription: String = """
      |Website built with Kobweb (Kotlin/JS), MVI architecture with ViewModels managing data loading; data structures divided into layers due to domain complexity. Static site — no application backend.
      |    Task data stored in SQLite, exported to JSON files by a Python script and bundled with the site. Task content rendered by MathJax (LaTeX in the browser). Task images are generated from LaTeX source files — compiled to PDF, then converted to SVG using pdf2svg. Dark variants of images generated automatically by a separate Python script. Copying a task to the clipboard as an image is handled by Snapdom — enabling quick paste into a virtual whiteboard during online tutoring sessions.
      |        Google and Discord account login, along with premium feature management, handled by Supabase (Authentication + Database) with Stripe integration for payment processing. User data and purchased features stored in Supabase DB. Site hosted on a private server with a custom domain.
      """.trimMargin()

  override val projects_youtube_uploader_shortDescription: String =
      "Script for automated YouTube video uploads"

  override val projects_youtube_uploader_description: String =
      "Script for automated YouTube video uploads. Created for the Valorant Lineups and Math Exams applications – I needed to record over 1,000 videos, generate descriptions for them, and upload them to YouTube. The script automatically fetches data from a database, generates a title and description based on a template, uploads everything to the platform, and saves the link for each record back in the database."

  override val projects_video_processor_shortDescription: String =
      "An application for adding subtitles to a video extremely fast"

  override val projects_video_processor_description: String =
      "An application for adding subtitles to a video extremely fast. Created for Valorant Lineups, where I needed to add short explanatory subtitles for certain videos. Existing tools didn't allow editing a video in this specific way within a few seconds while overwriting the original file in place, whereas my application enables exactly that."

  override val projects_connect_four_shortDescription: String =
      "Browser-based version of the Connect Four game"

  override val projects_connect_four_description: String =
      "Browser-based version of the Connect Four game. Built in Compose HTML using the official JetBrains template. Created as a project for a JetBrains internship. Beyond standard gameplay, the game features animations, state preservation upon refresh, responsiveness, and highlighting of the winning four."

  override val projects_daymath_image_viewer_shortDescription: String =
      "An application for viewing images rendered from LaTeX code"

  override val projects_daymath_image_viewer_description: String =
      "An application for viewing images rendered from LaTeX code. It allows me to quickly check for typos or other errors when working on tasks in the DayMath app."

  override val projects_tutoring_work_sheet_shortDescription: String =
      "An application for tracking my tutoring earnings and tax deductions"

  override val projects_tutoring_work_sheet_description: String =
      "An application for tracking my tutoring earnings and tax deductions."

  override val projects_coroutines_learning_shortDescription: String =
      "A set of 15 projects for learning coroutines from scratch - not done yet"

  override val projects_coroutines_learning_description: String =
      "A set of 15 projects for learning coroutines from scratch. Initially console applications, later featuring a graphical user interface. Details available in the repository's README file."

  override val experience_title: String = "Experience"

  override val experience_subtitle: String =
      "A collection of my professional experience, including tutoring and app development."

  override val experience_tutor_title: String = "Math Tutor"

  override val experience_tutor_responsibility_1: String =
      "Conducting private 1-on-1 lessons with students"

  override val experience_tutor_responsibility_2: String =
      "Preparing students for high school graduation and eighth-grade exams"

  override val experience_tutor_responsibility_3: String =
      "Creating learning materials using LaTeX and Manim"

  override val experience_app_developer_title: String = "Commercial App Developer"

  override val experience_app_developer_responsibility_1: String =
      "Creating my own mobile applications for Android"

  override val experience_app_developer_responsibility_2: String =
      "Developing applications based on user needs"

  override val students_taught: String = "Students taught"

  override val rating: String = "Rating"

  override val reviews: String = "Reviews"

  override val apps_published: String = "Apps published"

  override val total_downloads: String = "Total downloads"

  override val home: String = "Home"

  override val self_employed: String = "Self-employed"

  override val commercial: String = "Commercial"

  override val primary_technologies: String = "Primary Technologies"

  override val education_title: String = "Education"

  override val education_subtitle: String =
      "A collection of my education, including my Bachelor's degree and high school."

  override val education_uj_degree: String = "Bachelor degree of Computer Science"

  override val education_uj_organization: String = "Jagiellonian University"

  override val education_zsz_degree: String = "IT Technician"

  override val education_zsz_organization: String = "Zespół Szkół Zawodowych w Przeworsku"

  override val Poland: String = "Poland"

  override val Algebra: String = "Algebra"

  override val ComputerOrganizationAndArchitecture: String =
      "Computer Organization and Architecture"

  override val Programming: String = "Programming"

  override val LogicAndSetTheory: String = "Logic and Set Theory"

  override val MathematicalAnalysis: String = "Mathematical Analysis"

  override val ProgrammingMethods: String = "Programming Methods"

  override val OperatingSystems: String = "Operating Systems"

  override val AlgorithmsAndDataStructures: String = "Algorithms and Data Structures"

  override val DiscreteMathematics: String = "Discrete Mathematics"

  override val Databases: String = "Databases"

  override val SoftwareEngineering: String = "Software Engineering"

  override val ProbabilityAndStatistics: String = "Probability and Statistics"

  override val ComputerNetworks: String = "Computer Networks"

  override val FormalLanguagesAndAutomata: String = "Formal Languages and Automata"

  override val NumericalMethods: String = "Numerical Methods"

  override val FunctionalProgramming: String = "Functional Programming"

  override val AndroidProgramming: String = "Android Programming"

  override val DesignPatterns: String = "Design Patterns"

  override val CSharpProgramming: String = "C# Programming"

  override val CognitiveSystems: String = "Cognitive Systems"

  override val CognitiveScience: String = "Cognitive Science"

  override val WebProgramming: String = "Web Programming"

  override val FundamentalsOfAI: String = "Fundamentals of AI"

  override val English: String = "English"

  override val Networking: String = "Networking"

  override val HardwareMaintenance: String = "Hardware Maintenance"

  override val CertificateCCNARoutingAndSwitchingIntroductionToNetworks: String =
      "Certificate: CCNA Routing and Switching: Introduction to Networks"

  override val CertificatePCAPProgrammingEssentialsInPython: String =
      "Certificate: PCAP: Programming Essentials in Python"

  override val CertificateNDGLinuxUnhatched: String = "Certificate: NDG Linux Unhatched"

  override val CertificateIntroductionToCybersecurity: String =
      "Certificate: Introduction to Cybersecurity"

  override val CertificateCybersecurityEssentials: String = "Certificate: Cybersecurity Essentials"

  override val CertificateBeYourOwnBoss: String = "Certificate: Be Your Own Boss"

  override val CertificateGetConnected: String = "Certificate: Get Connected"

  override val CertificateIntroductionToTheInternetOfEverything: String =
      "Certificate: Introduction to the Internet of Everything"

  override val Certificate3dsMaxAnimation: String = "Certificate: 3ds Max Animation"

  override val Certificate3dsMaxVisualisation: String = "Certificate: 3ds Max Visualisation"

  override val Certificate3dsMaxModeling: String = "Certificate: 3ds Max Modeling"

  override val CertificateEUCodeWeek: String = "Certificate: EU Code Week"

  override val CertificateCPAProgrammingEssentialsInCPlusPlus: String =
      "Certificate: CPA: Programming Essentials in C++"

  override val programming_and_software_engineering: String = "Programming and Software Engineering"

  override val mathematics: String = "Mathematics"

  override val systems_and_computer_technology: String = "Systems and Computer Technology"

  override val ai_and_cognitive_science: String = "AI and Cognitive Science"

  override val courses: String = "Courses"

  override val professional_certificates: String = "Professional Certificates"

  override val achievements_title: String = "Achievements"

  override val achievements_subtitle: String =
      "A collection of my achievements, including awards and recognitions in various contests."

  override val programming_competitions: String = "Programming Competitions"

  override val math_competitions: String = "Math Competitions"

  override val scholarships: String = "Scholarships"

  override val other_achievements: String = "Other Achievements"

  override val FirstPlaceInTheIndependenceDictationContest: String =
      "1st Place in the Independence Dictation Contest"

  override val PrzeworskCountyScholarship: String = "Przeworsk County Scholarship"

  override val FirstPlaceInTheExpertGroupAtThePix2019ContestNationalSchoolProgrammingChampionship:
      String =
      "1st Place in the EXPERT Group at the PIX 2019 Contest - National School Programming Championship"

  override val QualificationToTheSemiFinalsOfThePolishEditionOfTheInternationalPixProgrammingChallenge:
      String =
      "Qualification to the Semi-Finals of the Polish Edition of the International Pix Programming Challenge"

  override val HonorableMentionInTheNationalHistoryContestKrag: String =
      "Honorable Mention in the National History Contest \"Krąg\""

  override val SecondPlaceInThe24thProfJanMarszalMathematicsContestForMiddleSchools: String =
      "2nd Place in the 24th Prof. Jan Marszał Mathematics Contest for Middle Schools"

  override val FirstPlaceInTheSchoolProgrammingContest: String =
      "1st Place in the School Programming Contest"

  override val HonorableMentionInThe15thDistrictMathContestProcent: String =
      "Honorable Mention in the 15th District Math Contest \"Procent\""

  override val FirstPlaceInThe14thDistrictMathContestForSecondYearMiddleSchoolStudents: String =
      "1st Place in the 14th District Math Contest for Second-Year Middle School Students"

  override val SecondPlaceInTheSchoolEnglishContest: String =
      "2nd Place in the School English Contest"

  override val HonorableMentionInTheInternationalMathContestKangurMatematyczny: String =
      "Honorable Mention in the International Math Contest \"Kangur Matematyczny\""

  override val first_place: String = "1st place"

  override val school: String = "School"

  override val regional: String = "Regional"

  override val national: String = "National"

  override val international: String = "International"

  override val district: String = "District"

  override val social_media_title: String = "Social Media"

  override val social_media_subtitle: String =
      "Connect with me on social media to watch all my educational animations."

  override val january: String = "January"

  override val february: String = "February"

  override val march: String = "March"

  override val april: String = "April"

  override val may: String = "May"

  override val june: String = "June"

  override val july: String = "July"

  override val august: String = "August"

  override val september: String = "September"

  override val october: String = "October"

  override val november: String = "November"

  override val december: String = "December"

  override val now: String = "Now"

  override val n_apps_published: VoidPluralString =
      VoidPluralString(PluralForms(one = "App published", other = "Apps published", ), "en")

  override val n_courses: LibresFormatNCourses =
      LibresFormatNCourses(PluralForms(one = "%1${'$'}s course", other = "%1${'$'}s courses", ), "en")

  override val n_certificates: LibresFormatNCertificates =
      LibresFormatNCertificates(PluralForms(one = "%1${'$'}s certificate", other = "%1${'$'}s certificates", ), "en")

  override val n_achievements: LibresFormatNAchievements =
      LibresFormatNAchievements(PluralForms(one = "%1${'$'}s achievement", other = "%1${'$'}s achievements", ), "en")

  override val n_years: LibresFormatNYears =
      LibresFormatNYears(PluralForms(one = "%1${'$'}s year", other = "%1${'$'}s years", ), "en")
}
